import { ProjectModelRelationType } from './project-model-relation-type.enum';

export const PROJECT_MODEL_RELATION_TYPE_OPTIONS = [
  {
    key: 'One to many (hasMany)',
    value: ProjectModelRelationType.HasMany
  },
  {
    key: 'Many to one (belongsTo)',
    value: ProjectModelRelationType.BelongsTo
  },
  {
    key: 'One to one (hasOne)',
    value: ProjectModelRelationType.HasOne
  },
  {
    key: 'Many to many (hasManyThrough)',
    value: ProjectModelRelationType.HasManyThrough
  },
  {
    key: 'References Many',
    value: ProjectModelRelationType.ReferencesMany
  }
];
